export const APP_TIMEZONE = "Europe/Berlin";
export const APP_LOCALE = "de-DE";
